import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {},
  discountedPrice: {
    color: theme.lightCoralColor,
    marginRight: '0.2rem',
  },
  price: (props: any) => ({
    textDecoration: props.isOnSale ? 'line-through' : 'none',
    color: props.isOnSale ? theme.darkGrayColor : theme.darkSlateGrayColor,
  }),
}));

export default useStyles;
